import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UiComponents, UnoStoreHooks, UnoActions } from "@simulanisindia/ui";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import "./App.css";
import Layout from "./Layout/Layout";
import { SECRET_KEY } from "./env";
import { fetchInitialAppData, getUserDetails } from "./Utils/apiCall";
import { removeUserData, saveUserLoading } from "./Store/slice/userSlice";

const { FullScreenLoader } = UiComponents;
const { useUnoSelector, useUnoDispatch } = UnoStoreHooks;
const { saveUserData } = UnoActions;


function App() {
  const dispatch = useDispatch();
  // const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const unoDispatch = useUnoDispatch()
  const [loading, setLoading] = useState(true)
  // const [defaultRoute, setDefaultRoute] = useState(null);
  const navigate = useNavigate();
  const currentURL = window.location.href;
  const urlObject = new URL(currentURL);
  const referrerUrlParam = urlObject.searchParams.get("referrer");

  // const userDetails = async (token, redirect) => {
  //   try {
  //     const decodeToken = jwtDecode(token, SECRET_KEY);
  //     await getUserDetails(decodeToken.uuid, dispatch, token);
  //     if (redirect) navigate(`/dashboard`);
  //   } catch (error) {
  //     console.log(error);
  //     dispatch(removeUserData());
  //     navigate(`/gateway`);
  //   }

  // }

  const handleReferrer = async (referrer) => {
    const decoded = jwtDecode(referrer);
    const { token, redirectUri } = decoded;
    localStorage.setItem("token", token);
    const userDetails = await getUserDetails(token)
    unoDispatch(saveUserData(userDetails.data))
    setLoading(false);
    navigate(redirectUri)
  }

  if (referrerUrlParam) {
    handleReferrer(referrerUrlParam)
  }

  const initializePage = async () => {
    try {
      const token = localStorage.getItem("token")
      if (token) {
        const userDetails = await getUserDetails(token);
        unoDispatch(saveUserData(userDetails.data))
      }
      setLoading(false)
    } catch (error) {
      localStorage.removeItem("token")
      setLoading(false)
    }
  }

  useEffect(() => {
    initializePage()
  }, []);
  useEffect(() => {
    if (userData?.token) {
      fetchInitialAppData(dispatch, userData?.token);
    }
  }, [userData?.token]);

  return <>
    {loading ?
      <FullScreenLoader loading={loading} />
      :
      <Layout />
    }

  </>
}

export default App;